<template>
  <div>
    <b-modal
      size="lg"
      v-model="visible"
    >
    <template slot="modal-title">
      {{titulo}}
    </template>

      <div>
        <b-row>
          <b-col lg="12">
            <b-form>
              <b-card-body>
                <b-row>
                  <b-col sm="6">
                    <!--
                    <b-form-group
                      :label="crearLabel('Nombre', 'gsanombre', 'datosFormulario')"
                      label-for="gsanombre">
                      <b-form-input
                        id="gsanombre"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gsanombre"
                        :disabled="campoBloqueado('gsanombre', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_actividades', 'gsanombre', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gsanombre }}
                      </span>
                    </b-form-group>
                    -->
                    <b-form-group
                      :label="crearLabel('Descripción', 'gsadescripcion', 'datosFormulario')"
                      label-for="gsadescripcion">
                      <b-form-input
                        id="gsadescripcion"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gsadescripcion"
                        :disabled="campoBloqueado('gsadescripcion', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_actividades', 'gsadescripcion', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gsadescripcion }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Automática', 'gsaautomatica', 'datosFormulario')"
                      label-for="gsaautomatica">
                      <b-form-select 
                        :options="valAutomatica"  
                        v-model="datosFormulario.gsaautomatica"
                        :disabled="campoBloqueado('gsaautomatica', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gsaautomatica }}
                      </span>
                    </b-form-group>
                    <!--
                    <b-form-group
                      :label="crearLabel('Secuencia', 'gsasecuencia', 'datosFormulario')"
                      label-for="gsasecuencia">
                      <b-form-select 
                        :options="valSecuencia"  
                        v-model="datosFormulario.gsasecuencia"
                        :disabled="campoBloqueado('gsasecuencia', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gsasecuencia }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Pantalla', 'gsapantalla', 'datosFormulario')"
                      label-for="gsapantalla">
                      <b-form-input
                        id="gsapantalla"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gsapantalla"
                        :disabled="campoBloqueado('gsapantalla', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_actividades', 'gsapantalla', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gsapantalla }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Proceso', 'gsaproceso', 'datosFormulario')"
                      label-for="gsaproceso">
                      <b-form-input
                        id="gsaproceso"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gsaproceso"
                        :disabled="campoBloqueado('gsaproceso', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_actividades', 'gsaproceso', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gsaproceso }}
                      </span>
                    </b-form-group>
                    -->
                  </b-col>

                  <b-col sm="6">  
                    <!--
                    <b-form-group
                      :label="crearLabel('Estado Instanciado', 'gsaprocestado', 'datosFormulario')"
                      label-for="gsaprocestado">
                      <b-form-select 
                        :options="valProcEstado"  
                        v-model="datosFormulario.gsaprocestado"
                        :disabled="campoBloqueado('gsaprocestado', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gsaprocestado }}
                      </span>
                    </b-form-group>
                    -->
                    <b-form-group
                      :label="crearLabel('Frecuencia', 'gsafrecuencia', 'datosFormulario')"
                      label-for="gsafrecuencia">
                      <b-form-select 
                        :options="valFrecuencia"  
                        v-model="datosFormulario.gsafrecuencia"
                        :disabled="campoBloqueado('gsafrecuencia', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gsafrecuencia }}
                      </span>
                    </b-form-group>

                     <b-form-group
                      :label="crearLabel('Día Programado', 'gsadiaprogramado', 'datosFormulario')"
                      label-for="gsadiaprogramado">
                      <b-form-input
                        id="gsadiaprogramado"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gsadiaprogramado"
                        :disabled="campoBloqueado('gsadiaprogramado', 'datosFormulario')"
                      >
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gsadiaprogramado }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Plazo', 'gsaplazo', 'datosFormulario')"
                      label-for="gsaplazo">
                      <b-form-select 
                        :options="valPlazo"  
                        v-model="datosFormulario.gsaplazo"
                        :disabled="campoBloqueado('gsaplazo', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gsaplazo }}
                      </span>
                    </b-form-group>
                   
                    <b-form-group
                      :label="crearLabel('Actividad Inicial', 'gspiniactivi', 'datosFormulario')"
                      label-for="gspiniactivi">
                      <b-form-select 
                        :options="valActividadInicial"
                        v-model="datosFormulario.gspiniactivi"
                        :disabled="campoBloqueado('gspiniactivi', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gspiniactivi }}
                      </span>
                    </b-form-group>

                  </b-col>
                </b-row>
              </b-card-body>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <p class="float-left"></p>
       <b-button
          type="submit"
          variant="primary"
          class="float-right"
          style="margin-right:8px;"
          @click="guardarActividad"
        > Guardar</b-button>
        
        <b-button
          type="submit"
          variant="secondary"
          class="float-right"
          style="margin-right:8px;"
          @click="modalEditarDependencia = false; visible = false;"
        > Cancelar</b-button>

      </div>
    </b-modal>
  
  </div>
</template>
<script>

import axios from "axios";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "../../components/mixins/globalesMixin";

export default {
  name: "EditarActividad",
  mixins: [globalesMixin],
  data: function() {
    return {
      titulo: "",
      visible: false,
      modalEditarActividad: false,
      modalAgregarActividad: false,
      datosFormulario: {
        gsaproced: "",
        gsanombre: "",
        gsadescripcion: "",
        gsaautomatica: "",
        gsasecuencia: "",
        gsapantalla: "",
        gsaproceso: "",
        gsaprocestado: "",
        gsafrecuencia: "",
        gsaplazo: "",
        gsadiaprogramado: "",
        desc_gspiniactivi: "",
        gspiniactivi: ""
      },

      valAutomatica: [],
      valSecuencia: [],
      valProcEstado: [],
      valFrecuencia: [],
      valPlazo: [],
      valActividadInicial: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {}
    };
  },
  methods: {
    obtenerActividad(mail, usuario, p_gsaproced, p_gsanombre, tiporec) {
      this.titulo = "Editar Actividad";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .buscarActividad(mail, usuario, p_gsaproced, p_gsanombre, tiporec)
        .then(response => {
          
          this.datosFormulario.gsaproced = p_gsaproced;
          this.datosFormulario.gsanombre = "";
          this.datosFormulario.gsadescripcion = "";
          this.datosFormulario.gsaautomatica = "";
          this.datosFormulario.gsasecuencia = "";
          this.datosFormulario.gsapantalla = "";
          this.datosFormulario.gsaproceso = "";
          this.datosFormulario.gsaprocestado = "";
          this.datosFormulario.gsafrecuencia = "";
          this.datosFormulario.gsaplazo = "";
          this.datosFormulario.gsadiaprogramado = "";

          response.data = this.keysMinuscula(response.data);
          this.datosFormulario = response.data.res[0];

          this.datosFormularioEstado = response.data.festado;

          //Carga lista de tipo de Automatica
          var tiposAutomatica = new Array();
          var lista_tipos_automaticas = response.data.automaticas;
          for(var i = 0; i < lista_tipos_automaticas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_automaticas[i]["gsaautomatica"];
              obj.text = lista_tipos_automaticas[i]["desc_automatica"];
              tiposAutomatica.push(obj);
          }
          this.valAutomatica = tiposAutomatica;

          //Carga lista de tipo de Secuencia
          var tiposSecuencia = new Array();
          var lista_tipos_secuencias = response.data.secuencias;
          for(var i = 0; i < lista_tipos_secuencias.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_secuencias[i]["secuencia"];
              obj.text = lista_tipos_secuencias[i]["secuencia"];
              tiposSecuencia.push(obj);
          }
          this.valSecuencia = tiposSecuencia;

          //Carga lista de tipo de Frecuencias
          var tiposFrecuencia = new Array();
          var lista_tipos_frecuencias = response.data.frecuencias;
          for(var i = 0; i < lista_tipos_frecuencias.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_frecuencias[i]["gsafrecuencia"];
              obj.text = lista_tipos_frecuencias[i]["desc_frecuencia"];
              tiposFrecuencia.push(obj);
          }
          this.valFrecuencia = tiposFrecuencia;


          //Carga lista de tipo de ProEst
          var tiposProEst = new Array();
          var lista_tipos_proest = response.data.gentproest;
          for(var i = 0; i < lista_tipos_proest.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_proest[i]["gpecodigo"];
              obj.text = lista_tipos_proest[i]["gpedescripcion"];
              tiposProEst.push(obj);
          }
          this.valProcEstado = tiposProEst;

          //Carga lista de tipo de Plazo
          var tiposPlazo = new Array();
          var lista_tipos_plazo = response.data.plazos;
          for(var i = 0; i < lista_tipos_plazo.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_plazo[i]["gsaplazo"];
              obj.text = lista_tipos_plazo[i]["desc_plazo"];
              tiposPlazo.push(obj);
          }
          this.valPlazo = tiposPlazo;


          //Carga lista de tipo actividad inicial
          var tiposActividadini = new Array();
          var lista_tipos_actividad_ini = response.data.actividad_ini;
          for(var i = 0; i < lista_tipos_actividad_ini.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_actividad_ini[i]["gspiniactivi"];
              obj.text = lista_tipos_actividad_ini[i]["desc_gspiniactivi"];
              tiposActividadini.push(obj);
          }
          this.valActividadInicial = tiposActividadini;



          this.modalEditarActividad = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    pre_insertar(mail, usuario, p_gsaproced, p_gsanombre) {
      this.titulo = "Agregar Actividad";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .pre_insertarActividad(mail, usuario, p_gsaproced, p_gsanombre)
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.gsaproced = p_gsaproced;
          this.datosFormulario.gsanombre = "";
          this.datosFormulario.gsadescripcion = "";
          this.datosFormulario.gsaautomatica = "";
          this.datosFormulario.gsasecuencia = "";
          this.datosFormulario.gsapantalla = "";
          this.datosFormulario.gsaproceso = "";
          this.datosFormulario.gsaprocestado = "";
          this.datosFormulario.gsafrecuencia = "";
          this.datosFormulario.gsaplazo = "";
          this.datosFormulario.gsadiaprogramado = "";
          this.datosFormulario.desc_gspiniactivi = "";
      
          this.datosFormularioEstado = response.data.festado;

          //Carga lista de tipo de Automatica
          var tiposAutomatica = new Array();
          var lista_tipos_automaticas = response.data.automaticas;
          for(var i = 0; i < lista_tipos_automaticas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_automaticas[i]["gsaautomatica"];
              obj.text = lista_tipos_automaticas[i]["desc_automatica"];
              tiposAutomatica.push(obj);
          }
          this.valAutomatica = tiposAutomatica;

          //Carga lista de tipo de Secuencia
          var tiposSecuencia = new Array();
          var lista_tipos_secuencias = response.data.secuencias;
          for(var i = 0; i < lista_tipos_secuencias.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_secuencias[i]["secuencia"];
              obj.text = lista_tipos_secuencias[i]["secuencia"];
              tiposSecuencia.push(obj);
          }
          this.valSecuencia = tiposSecuencia;

          //Carga lista de tipo de Frecuencias
          var tiposFrecuencia = new Array();
          var lista_tipos_frecuencias = response.data.frecuencias;
          for(var i = 0; i < lista_tipos_frecuencias.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_frecuencias[i]["gsafrecuencia"];
              obj.text = lista_tipos_frecuencias[i]["desc_frecuencia"];
              tiposFrecuencia.push(obj);
          }
          this.valFrecuencia = tiposFrecuencia;


          //Carga lista de tipo de ProEst
          var tiposProEst = new Array();
          var lista_tipos_proest = response.data.gentproest;
          for(var i = 0; i < lista_tipos_proest.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_proest[i]["gpecodigo"];
              obj.text = lista_tipos_proest[i]["gpedescripcion"];
              tiposProEst.push(obj);
          }
          this.valProcEstado = tiposProEst;

          //Carga lista de tipo de Plazo
          var tiposPlazo = new Array();
          var lista_tipos_plazo = response.data.plazos;
          for(var i = 0; i < lista_tipos_plazo.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_plazo[i]["gsaplazo"];
              obj.text = lista_tipos_plazo[i]["desc_plazo"];
              tiposPlazo.push(obj);
          }
          this.valPlazo = tiposPlazo;


          //Carga lista de tipo actividad inicial
          var tiposActividadini = new Array();
          var lista_tipos_actividad_ini = response.data.actividad_ini;
          for(var i = 0; i < lista_tipos_actividad_ini.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_actividad_ini[i]["gspiniactivi"];
              obj.text = lista_tipos_actividad_ini[i]["desc_gspiniactivi"];
              tiposActividadini.push(obj);
          }
          this.valActividadInicial = tiposActividadini;
         
          this.modalAgregarActividad = true;
          this.visible = true;

          console.log(this.datosFormulario);

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    guardarActividad(event) {
      event.preventDefault();
      this.$Progress.start();
      
      
      if (this.modalEditarActividad){
        return apiActividades
        .modificarActividad(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaActividades");
            this.modalEditarActividad = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else if (this.modalAgregarActividad) {
        return apiActividades
        .insertarActividad(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaActividades");
            this.modalAgregarActividad = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

    }
    
  }
};
</script>
<style scoped>
</style>
